const en = {
  nav: {
    home: 'Home',
    blog: 'Blog',
    resume: 'Resume',
  },
  seo: {
    defaultTitle: 'Diego Garcia - Full-Stack Software Engineer & Architect',
    defaultDescription: 'Experienced Full-Stack Software Engineer focused on building scalable, optimized and performant solutions. 20+ years of experience in .NET, React, Flutter, and cloud technologies.',
  },
  lang: {
    en: 'EN',
    pt: 'PT',
    fr: 'FR',
  },
  jobTitle: 'Full-Stack Software Engineer & Architect',
  home: {
    available: 'Available for opportunities',
    headline1: "Hi, I'm",
    heroPart1: 'I love to build ',
    descriptionBold: 'scalable, optimized and performant solutions',
    heroPart2: ' for companies and sharing knowledge through writing.',
    badge1: '.NET Expert',
    badge2: 'Full Stack',
    ctaBlog: 'Read my blog',
    ctaResume: 'View resume',
    findMeOn: 'Find me on:',
    whatIDo: {
      title: 'What I Do',
      subtitle: 'I specialize in building robust, scalable applications across the full stack',
      cards: [
        {
          icon: '🏗️',
          title: 'System Architecture',
          description: 'Designing microservices, APIs, and distributed systems that scale.',
        },
        {
          icon: '💻',
          title: 'Full-Stack Development',
          description: 'Building end-to-end solutions with .NET, React, Flutter, and cloud technologies.',
        },
        {
          icon: '✍️',
          title: 'Technical Writing',
          description: 'Sharing insights on design patterns, best practices, and engineering culture.',
        },
      ],
    },
  },
  resume: {
    relevantExperience: 'Relevant Experience',
    lastExperience: 'Last Experience',
    skills: 'Skills',
    education: 'Education',
    languages: 'Languages',
    selectedProjects: 'Selected Projects',
  },
  footer: {
    rights: 'All rights reserved.',
    builtWith: 'Built with React & ❤️',
  },
  blog: {
    featuredTitle: 'Latest Articles',
    featuredSubtitle: 'Thoughts on engineering and architecture',
    viewAll: 'View all',
    viewAllArticles: 'View all articles',
    readMore: 'Read more',
    backToBlog: 'Back to Blog',
    backToHome: 'Home',
    minuteRead: 'min read',
    searchPlaceholder: 'Search articles...',
    all: 'All',
    noPostsFound: 'No posts found',
    noPostsSubtitle: 'Try adjusting your search terms',
    noPostsAvailable: 'No posts available yet.',
    clearFilters: 'Clear filters',
    article: 'article',
    articles: 'articles',
    failedToLoad: 'Failed to load blog posts.',
    tryAgain: 'Try Again',
    featured: 'Featured',
    backToTop: 'Top',
    relatedArticles: 'Related Articles',
    categories: {
      'design-patterns': 'Design Patterns',
      'system-architecture': 'System Architecture',
      'frontend-patterns': 'Frontend Patterns',
      'tooling': 'Tooling',
      'best-practices': 'Best Practices',
    },
  },
};

export default en;
